export default __webpack_public_path__ + "static/media/936.a6b85dac.png";